import React from "react";
import MarketPulseHubContainer from "containers/AllInOneDashboard/MarketPulseHubContainer";

const MarketPulseHub = () => <MarketPulseHubContainer />;

export default MarketPulseHub;
